/**
 * 路由权限
 */

import router from "@/router/index";
import { getToken } from "@/utils/cache";
import store from "@/store";

const white_list = [
  '/inspiration',
  '/album',
  '/consultative',
  '/login',
  '/',
  "/abroad-ip-goods",
  "/china-ip-goods",
  "/interface",
  "/Introduce",
  "/faq",
  "/FaqDetail",
  "/service",
];


router.beforeEach(async (to, from, next) => {

  const hasToken = getToken()
  if (to.query.auth_code) {
    await store.dispatch('user/resetToken')
    
    next()
    return
  }
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: from.path })
    } else {

      try {
        await store.dispatch('user/checkToken')
        next()
      } catch (error) {
        await store.dispatch('user/resetToken')
        next(`/login?redirect=${to.path}`)
      }
    }
  } else {
    if (white_list.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})
